module.exports = __webpack_public_path__ + "img/5.d9e8fa66.webp";